import dayjs from 'dayjs'

import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import { getCurrentLocale, ValidLocale } from '@localisation/utils.ts'

// Registered up front rather than imported on demand: dayjs keeps its built-in
// US locale when the requested locale data is missing, so dates rendered before
// an async import resolved came out as MM/DD/YYYY.
import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/fi'
import 'dayjs/locale/sv'

export const setDayJsLocale = (locale: ValidLocale) => {
  dayjs.locale(locale)
}

export const initializeDayJs = () => {
  dayjs.extend(relativeTime)
  dayjs.extend(localizedFormat)
  setDayJsLocale(getCurrentLocale())
}
